/**
 * Sets the value of a cookie.
 * @param {string} name Name of the cookie.
 * @param {any} value Value of the cookie.
 * @param {number} days Number of days before the cookie expires.
 * @param {string} domain The host to which the cookie will be sent.
 */
function setCookie(name, value, days = 365, domain = '') {

    if (domain != '') {
        domain = ';domain =' + domain;
    };

    let expires = "",
        date = new Date();

    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toGMTString();

    document.cookie = name + '=' + value + expires + '; path=/' + domain;
}

/**
 * Gets the value of a cookie.
 * @param {string} name Name of the cookie.
 * @returns {string} Value of the cookie.
 */
function getCookie(name) {
    const nameEq = name + '=',
        ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEq) === 0) {
            return c.substring(nameEq.length, c.length);
        }
    }

    return null;
}

/**
 * Clears and removes a cookie.
 * @param {string} name Name of the cookie.
 */
function clearCookie(name) {
    setCookie(name, '', -1);
}

export { setCookie, getCookie, clearCookie };